import { getCurrentUserName } from "../queries/AuthToken";
import { dataRequest, postRequest } from "./DataRequest";
import { SharedReportDocuments } from "../types/SharedReportDocuments";

export const getSharedDefects = async (userId: string | undefined) => {
  return await dataRequest(`/Fleet/sharedDefects/${userId}`);
};

export const shareDefects = async (
  defects: any,
  name: string,
  email: string,
  message: string,
  shareReport: boolean
) => {
  const currentUser = await getCurrentUserName();

  const data = {
    defects: defects,
    name: name,
    email: email,
    sharerName: currentUser,
    message: message,
    shareReport: shareReport,
  };

  return await postRequest("/Defects/share", data);
};

export const getSharedReportDocuments = async (
  inspectionId: string
): Promise<SharedReportDocuments> => {
  return await dataRequest(`/SharedDefects/documents/${inspectionId}`);
};

export const getPreviousRecipients = async () => {
  return await dataRequest(`/Defects/technicalManagers`);
};
